enum EligibilityStatusCode {
	NOT_CHECKED = 'NotChecked',
	PASS = 'Pass',
	FAIL = 'Fail',
}

export default EligibilityStatusCode;